type DownloadIconProps = {
  onClick?: () => void;
};

export const DownloadIcon: React.FC<DownloadIconProps> = ({ onClick }) => (
  <svg
    onClick={onClick}
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4657 0.134605H3.8379C1.8794 0.134605 0.286133 1.72787 0.286133 3.68637V6.70538C0.286133 7.19565 0.683626 7.59332 1.17408 7.59332C1.66452 7.59332 2.06202 7.19565 2.06202 6.70538V3.68637C2.06202 2.70704 2.85874 1.91049 3.8379 1.91049H19.4657C20.4448 1.91049 21.2416 2.70704 21.2416 3.68637V6.70538C21.2416 7.19565 21.6391 7.59332 22.1295 7.59332C22.62 7.59332 23.0175 7.19565 23.0175 6.70538V3.68637C23.0175 1.72787 21.4242 0.134605 19.4657 0.134605ZM12.5841 4.57449V15.052C12.5841 16.0312 11.7874 16.8279 10.8082 16.8279H7.09172L11.0689 20.8283C11.2361 20.9967 11.4589 21.0893 11.6962 21.0893C11.9334 21.0893 12.1563 20.9967 12.3235 20.8283L16.3007 16.8279H15.4255C14.9351 16.8279 14.5376 16.4303 14.5376 15.94C14.5376 15.4495 14.9351 15.052 15.4255 15.052H16.4018C17.1022 15.052 17.729 15.4709 17.9987 16.1191C18.2694 16.77 18.1235 17.5131 17.6272 18.0124L13.5829 22.0805C13.0798 22.5865 12.4098 22.8652 11.6962 22.8652C10.9825 22.8652 10.3126 22.5865 9.80949 22.0805L5.76519 18.0124C5.26884 17.5131 5.12299 16.77 5.39371 16.1191C5.66321 15.4709 6.29015 15.0519 6.99062 15.0519H10.8082V4.57449C10.8082 4.08404 11.2057 3.68655 11.6962 3.68655C12.1866 3.68655 12.5841 4.08421 12.5841 4.57449Z"
      fill="#ADC2E2"
    />
  </svg>
);
